import { ResourceLanguage } from 'i18next';
import { TranslationExtensionInterface } from '../interface/translation.extension.interface';

export class BikeleasingBenefitTranslationExtension extends TranslationExtensionInterface {
  moduleName = 'bikeleasing_v2_benefit';
  get translations(): ResourceLanguage {
    return {
      de: {
        fields: {
          condition: 'Bikeleasing Kondition',
          bikeleasingSecret: {
            label: 'Bikeleasing Secret',
            connectButton: 'Verbinden',
            conflictMessage: 'Dieser Bikeleasing Account ist bereits verknüpft.',
            successMessage: 'Verbindung hinzugefügt',
          },
        },
        addCondition: 'Neue Verbindung hinzufügen',
        deleteCondition: 'Verbindung trennen',
        confirmDeleteCondition:
          'Sind Sie sicher, dass Sie die ausgewählte Verbindung zu Bikeleasing trennen möchten?<br/><br/>Dadurch werden die zugehörigen Informationen aus dem Probonio-System entfernt, und bestehende Benefit-Aktivierungen für Mitarbeiter zum Ende des Vormonats beendet.',
        lastSync: '<strong>Letzte Sychronisierung</strong>: {{date , datetime}}',
        syncErrorDescription: {
          AUTH: 'Probonio konnte sich nicht bei Bikeleasing anmelden. Bitte prüfen Sie im Bikeleasing Portal ob die Verbindung noch verfügbar ist.',
          UNAVAILABLE: 'Konnten Bikleasing nicht erreichen. Bitte versuchen Sie es später erneut',
          INTERNAL: 'Bei der Synchronisation ist ein Fehler aufgetreten.',
        },
        syncError: 'Sync erfolgreich',
        syncSuccess: 'Synchronisierung erfolgreich',
        integrationSubTitle: 'Verbindungen',
        integration: {
          bikeleasingPortal: 'Jetzt Kunde werden',
        },
        connectNow: 'Gleich gehts los verbinden Sie nur noch Ihren Bikeleasing-Account!',
        noAccount: {
          info1:
            'Als Probonio-Kunde wissen Sie, wie Sie Ihr Team mit steuerfreien Benefits begeistern und Ihr Employer Branding stärken können',
        },
        advantages: {
          title: 'Ihre Vorteile beim Dienstrad-Leasing mit dem Bikeleasing-Service',
          lessCosts: {
            title: 'Weniger Kosten',
            description: 'Dank steuerlicher Förderung und Gehaltsumwandlung sparen Arbeitgeber und Beschäftigte.',
          },
          climateFriendly: {
            title: 'Mehr Nachhaltigkeit',
            description: 'Mit Dienstrad-Leasing fördern Sie umweltfreundliche und gesunde Mobilität in Ihrem Unternehmen.',
          },
          security: {
            title: 'Umfassende Absicherung',
            description:
              'Kündigung, Krankheit oder Elternzeit Ihrer Mitarbeiter sind ebenso abgesichert wie Diebstahl, Unfallschäden & Co.',
          },
        },
        questions: {
          title: 'Sie haben Fragen zum Bikeleasing-Service?',
          description:
            'Kontaktieren Sie das Bikeleasing-Team gerne per E-Mail an {{mail}} oder telefonisch unter {{tel}}. Mehr Informationen rund um das Dienstrad-Leasing finden Sie unter <0> {{web}} </0>',
        },
        companyCode: 'Aktuelle Konditionen für den Firmencode: {{companyCode}}',
        conditionDetailDialog: {
          alert:
            'Um das Bikeleasing-Benefit für Ihre Mitarbeiter anbieten zu können, schließen Sie zunächst einen Vertrag mit Bikeleasing ab.',
          alertAction: 'Mehr dazu',
          noOptions: 'Keine Konditionen verfügbar',
          title: 'Kondition',
        },
        leasingDurationInMonths: 'Leasingdauer in Monaten',
        allowedBikeTypes: 'Fahrradarten',
        maxNumberOfBikesPerEmployee: 'max. Anzahl Fahrräder/Mitarbeiter',
        minPurchasePrice: 'Fahrradmindestwert (Brutto)',
        maxPurchasePrice: 'Fahrradhöchstwert (Brutto)',
        employerContribution: 'Arbeitgeberanteil',
        priceRestrictions: {
          maxTotalPurchasePriceForAllBikes: 'Maximalbetrag/Mitarbeiter (Brutto)',
        },
        contracts: 'Verträge',
        contractLabel: 'Vertrag',
        contractIntro: 'Die Daten des abgeschlossenen Bikeleasing-Vertrags werden unten angezeigt.',
        contractAppInfo: 'Die Daten sind für den Mitarbeiter in der Probonio-App einsehbar.',
        contractDetails: 'Vertrag von {{name}}',
        contractAllDamageReports: 'Alle Schadenmeldungen',
        contractDownloadAll: 'Alle Verträge herunterladen',
        contractsTable: {
          startDownload: 'Verträge herunterladen',
          downloadError: 'Der Vertrags-Download konnte nicht vorbereitet werden.',
          prepareDownload: 'Download wird vorbereitet...',
          downloadReady: 'Verträge zum Download bereit',
          contractsActive: 'Aktive Verträge',
          contractsInactive: 'Inaktive Verträge',
          contractsAll: 'Alle',
          noResults: 'Keine Einträge vorhanden',
          header: {
            name: 'Mitarbeiter',
            startDate: 'Leasingbeginn',
            endDate: 'Leasingende',
            contractNumber: 'Vertragsnummer',
            bike: 'Fahrrad',
            status: 'Status',
          },
        },
        contract: {
          status: {
            EMPLOYEE_APPROVAL_REQUIRED: 'Unterschrift Arbeitnehmer erforderlich',
            EMPLOYER_APPROVAL_REQUIRED: 'Freigabe Arbeitgeber erforderlich',
            EMPLOYER_APPROVAL_DONE: 'Freigabe Arbeitgeber erfolgt',
            REQUESTED: 'Beantragt',
            CANCELLED_OR_REJECTED: 'Storniert/Abgelehnt',
            BIKE_TRANSFER_REQUIRED: 'Radübergabe erforderlich',
            BIKE_TRANSFER_DONE: 'Radübergabe erfolgt',
            ACTIVE: 'Aktiv',
            EXPIRING: 'Auslaufend',
            FINISHED: 'Beendet',
            BIKE_SHIPPED: 'Rad versendet',
            UNKNOWN: 'Unbekannt',
          },
          contractNumber: 'Vertragsnummer',
          trailerRecommendedRetailPrice: 'Anhänger UVP',
          recommendedRetailPrice: 'UVP',
          purchasePrice: 'Kaufpreis',
          employerContribution: 'Arbeitgeberzuschuss',
          salaryConversion: 'Gehaltsumwandlung',
          leasingDuration: 'Leasing Dauer',
          benefitInKind: 'Geldwerter Vorteil',
          insuranceCoverage: 'Versicherungsschutz',
          startDate: 'Vertragsbeginn',
          transferDate: 'Übergabe-Datum',
          leasingRate: 'Leasing-Rate',
          endDate: 'Vertragsende',
          brand: 'Marke',
          model: 'Modell',
          frameSize: 'Rahmengröße',
          items: 'Accessories',
          lockBrand: 'Schlossmarke',
        },
        section: {
          contract: 'Vertragsdaten',
          leasing: 'Leasing',
          bike: 'Fahrraddaten',
          benefits: 'Ihre Leistungen',
        },
      },
      en: {
        fields: {
          condition: 'Bikeleasing Conditions',
          bikeleasingSecret: {
            label: 'Bikeleasing Secret',
            connectButton: 'Connect',
            conflictMessage: 'Bikeleasing Account already connected.',
            successMessage: 'Connection added',
          },
        },
        addCondition: 'Add new Connection',
        deleteCondition: 'Disconnect',
        confirmDeleteCondition:
          'Are you sure that you want to disconnect the selected connection to Bike Leasing??<br/><br/>This will remove the associated information from the Probonio system and terminate existing employee benefit activations at the end of the previous month.',
        lastSync: '<strong>Last sync</strong>: {{date , datetime}}',
        syncErrorDescription: {
          AUTH: 'Probonio could not log in to Bikeleasing. Please check the bike leasing portal to see if the connection is still available.',
          UNAVAILABLE: "Couldn't reach Bikeleasing. Please try again later",
          INTERNAL: 'An error occurred during synchronization.',
        },
        syncError: 'Sync successful',
        syncSuccess: 'Sync successful',
        integrationSubTitle: 'Connections',
        integration: {
          bikeleasingPortal: 'Become a customer now',
        },
        connectNow: 'Just connect your Bikeleasing account!',
        noAccount: {
          info1: 'As a Probonio customer, you know how to inspire your team with tax-free benefits and strengthen your employer branding',
        },

        advantages: {
          title: 'Your benefits of company Bikeleasing with the Bikeleasing-Service',
          lessCosts: {
            title: 'Lower costs',
            description: 'Employers and employees save thanks to tax incentives and deferred compensation.',
          },
          climateFriendly: {
            title: 'More sustainability',
            description: 'With company Bikeleasing, you promote environmentally friendly and healthy mobility in your company.',
          },
          security: {
            title: 'Comprehensive protection',
            description: 'Termination, illness or parental leave of your employees are covered, as are theft, accidental damage, etc.',
          },
        },
        questions: {
          title: 'You have questions about the Bikeleasing-Service?',
          description:
            'Feel free to contact the Bikeleasing team by email at {{mail}} or by phone at {{tel}}. You can find more information about company bike leasing at <0>{{web}}</0>.',
        },
        companyCode: 'Current conditions for the company code: {{companyCode}}',
        conditionDetailDialog: {
          title: 'Terms and conditions',
          alertAction: 'Learn more about it',
          alert: 'To be able to offer the Bikeleasing benefit to your employees, you first conclude a contract with Bikeleasing.',
          noOptions: 'No conditions available',
        },
        leasingDurationInMonths: 'Leasing period in months',
        allowedBikeTypes: 'Bike types',
        maxNumberOfBikesPerEmployee: 'Max. number of bikes/employee',
        minPurchasePrice: 'Minimum bike value/employee (gross)',
        maxPurchasePrice: 'Maximum bike value/employee (gross)',
        employerContribution: 'Employer contribution',
        priceRestrictions: {
          maxTotalPurchasePriceForAllBikes: 'Maximum amount/employee (gross)',
        },
        contracts: 'Contracts',
        contractLabel: 'Contract',
        contractIntro: 'The details of the concluded Bikeleasing contract are displayed below.',
        contractAppInfo: 'The data can be viewed by the employee in the Probonio-app.',
        contractDetails: 'Contract from {{name}}',
        contractAllDamageReports: 'All damage reports',
        contractDownloadAll: 'Download all contracts',
        contractsTable: {
          startDownload: 'Download contracts',
          downloadError: 'Failed to prepare the contract download.',
          prepareDownload: 'Preparing download...',
          downloadReady: 'Contracts ready for download',
          contractsActive: 'Active contracts',
          contractsInactive: 'Inactive contracts',
          contractsAll: 'All',
          noResults: 'No results found',
          header: {
            name: 'Employee',
            startDate: 'Start of Leasing',
            endDate: 'End of Leasing',
            contractNumber: 'Contract Number',
            bike: 'Bike',
            status: 'Status',
          },
        },
        contract: {
          status: {
            EMPLOYEE_APPROVAL_REQUIRED: 'Employee signature required',
            EMPLOYER_APPROVAL_REQUIRED: 'Employer approval required',
            EMPLOYER_APPROVAL_DONE: 'Employer release required',
            REQUESTED: 'Applied for',
            CANCELLED_OR_REJECTED: 'Cancelled/denied',
            BIKE_TRANSFER_REQUIRED: 'Bike handover required',
            BIKE_TRANSFER_DONE: 'Bike handover takes place',
            ACTIVE: 'Active',
            EXPIRING: 'Expiring',
            FINISHED: 'Terminated',
            BIKE_SHIPPED: 'Bike shipped',
            UNKNOWN: 'Unknown',
          },
          contractNumber: 'Contract number',
          trailerRecommendedRetailPrice: 'Trailer RRP',
          recommendedRetailPrice: 'RRP',
          purchasePrice: 'Purchase price',
          employerContribution: 'Employer contribution',
          salaryConversion: 'Salary conversion',
          leasingDuration: 'Leasing duration',
          benefitInKind: 'Benefit in kind',
          insuranceCoverage: 'Insurance coverage',
          startDate: 'Contract start date',
          transferDate: 'Date of handover',
          leasingRate: 'Leasing rate',
          endDate: 'Contract end date',
          brand: 'Brand',
          model: 'Model',
          frameSize: 'Frame size',
          items: 'Accessory',
          lockBrand: 'Lock brand',
        },
        section: {
          contract: 'Contract data',
          leasing: 'Leasing',
          bike: 'Bike data',
          benefits: 'Your services',
        },
      },
    };
  }
}
